import { motion } from "framer-motion";
import iconList from './icon.svg'
import iconBlack from './iconblack.svg'
import './price-block.scss'
import popularIcon from './popularIcon.svg'

const fadeUp = {
    hidden: { opacity: 0, y: 38 },
    visible: (i = 0) => ({
        opacity: 1,
        y: 0,
        transition: {
            delay: i * 0.14,
            duration: 0.65,
            ease: "easeOut"
        }
    })
};

export default function PriceBlock() {
    return (
        <div className="price-block container">
            <motion.h3
                className="price-block__title"
                initial={{ opacity: 0, y: 32 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.1 }}
                transition={{ duration: 0.7, ease: "easeOut" }}
            >
                Choose the Right Plan for You
            </motion.h3>

            <div className="price-block__list">
                {/* BASIC */}
                <motion.div
                    className="price-block__item"
                    custom={0}
                    variants={fadeUp}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                >
                    {/* ...весь твой JSX без изменений... */}
                    <div className="price-block__item-top">
                        <span className="price-block__item-title">BASIC</span>
                        <span className="price-block__item-description">Ideal for beginners</span>
                    </div>
                    <div className="price-block__item-list">
                        <div className="price-block__item-list-item">
                            <img src={iconList} alt="" />
                            <span>Full access to all instruments</span>
                        </div>
                        <div className="price-block__item-list-item">
                            <img src={iconList} alt="" />
                            <span>Educational materials</span>
                        </div>
                        <div className="price-block__item-list-item">
                            <img src={iconList} alt="" />
                            <span>Dedicated support</span>
                        </div>
                    </div>
                    <div className="price-block__item-bottom">
                        <span className="price-block__item-from">From</span>
                        <span className="price-block__item-price">300$</span>
                        <a href={process.env.REACT_APP_LINK} className="price-block__item-button button">Open an Account</a>
                    </div>
                </motion.div>

                {/* PRO — с эффектом увеличения */}
                <motion.div
                    className="price-block__item price-block__item--popular"
                    custom={1}
                    variants={fadeUp}
                    initial="hidden"
                    whileInView="visible"
                    whileHover={{ scale: 1.05, boxShadow: "0 2px 38px #fd532f44" }}
                    viewport={{ once: true, amount: 0.1 }}
                    transition={{ type: "spring", stiffness: 350, damping: 18 }}
                >
                    <div className="price-block__popular">
                        <img src={popularIcon} alt="" />
                        <span>MOST POPULAR</span>
                    </div>
                    <div className="price-block__item-top">
                        <span className="price-block__item-title">PRO</span>
                        <span className="price-block__item-description">For experienced traders</span>
                    </div>
                    <div className="price-block__item-list">
                        <div className="price-block__item-list-item">
                            <img src={iconBlack} alt="" />
                            <span>Reduced fees</span>
                        </div>
                        <div className="price-block__item-list-item">
                            <img src={iconBlack} alt="" />
                            <span>Professional analytics</span>
                        </div>
                        <div className="price-block__item-list-item">
                            <img src={iconBlack} alt="" />
                            <span>Priority order execution</span>
                        </div>
                    </div>
                    <div className="price-block__item-bottom">
                        <span className="price-block__item-from">From</span>
                        <span className="price-block__item-price">2.000$</span>
                        <a href={process.env.REACT_APP_LINK} className="price-block__item-button button button--black">Open an Account</a>
                    </div>
                </motion.div>

                {/* VIP */}
                <motion.div
                    className="price-block__item"
                    custom={2}
                    variants={fadeUp}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                >
                    <div className="price-block__item-top">
                        <span className="price-block__item-title">VIP</span>
                        <span className="price-block__item-description">Premium features</span>
                    </div>
                    <div className="price-block__item-list">
                        <div className="price-block__item-list-item">
                            <img src={iconList} alt="" />
                            <span>Personal account manager</span>
                        </div>
                        <div className="price-block__item-list-item">
                            <img src={iconList} alt="" />
                            <span>Access to exclusive assets</span>
                        </div>
                        <div className="price-block__item-list-item">
                            <img src={iconList} alt="" />
                            <span>Top-tier execution priority</span>
                        </div>
                    </div>
                    <div className="price-block__item-bottom">
                        <span className="price-block__item-from">From</span>
                        <span className="price-block__item-price">15.000$</span>
                        <a href={process.env.REACT_APP_LINK} className="price-block__item-button button">Open an Account</a>
                    </div>
                </motion.div>
            </div>
        </div>
    );
}
